const ch = {
    common: {
        history: "历史版本"
    }
};
export default ch;



// WEBPACK FOOTER //
// ./src/i18n/langs/ch.js